<form #loginForm="ngForm" (ngSubmit)="submit()">
  <div class="card ms-lg-3 mt-3 p-5 text-center theme-tile-bg-color">
    <h3 [ngSwitch]="mode">
      <ng-container *ngSwitchCase="'refresh-session'">Your Session Has Expired</ng-container>
      <ng-container *ngSwitchCase="'routing'">Protected Content</ng-container>
      <ng-container *ngSwitchDefault>Welcome to {{ environment.domainName }}</ng-container>
    </h3>
    <h1 class="fw-bold mb-5 theme-text-title-color" [ngSwitch]="mode">
      <ng-container *ngSwitchCase="'refresh-session'">Sign In to Continue</ng-container>
      <ng-container *ngSwitchCase="'routing'">Sign In to Continue</ng-container>
      <ng-container *ngSwitchDefault>Sign In to Parent Account</ng-container>
    </h1>

    <!-- EMAIL -->
    <div class="form-floating mb-2">
      <input class="cwk-form-control form-control" id="email" name="email" [ngClass]="{'cwk-form-control-required': !credentials.Email && (email.dirty || email.touched), 'cwk-form-control-email': credentials.Email && email.errors && (email.dirty || email.touched) && email.errors['email']}" [(ngModel)]="credentials.Email" placeholder="Email" type="email" #email="ngModel" email required>
      <label for="email" i18n>Email</label>
    </div>

    <!-- PASSWORD -->
    <div class="form-floating mb-2 text-start">
      <input class="cwk-form-control form-control" id="password" maxlength="128" name="password" [ngClass]="{'cwk-form-control-required': !credentials.Password && (password.dirty || password.touched)}" [(ngModel)]="credentials.Password" placeholder="Password" type="password" autocomplete="off" #password="ngModel" required/>
      <label for="password" i18n>Password</label>
      <!--small class="ms-3" *ngIf="!credentials.Password && (password.dirty || password.touched)">This field is required</small-->
    </div>

    <!-- FORGOT PASSWORD -->
    <div class="text-end">
      <a class="cwk-link theme-text-title-color" (click)="goResetPassword()" i18n>Forgot password?</a>
    </div>

    <!-- REMEMBER MY EMAIL -->
    <div class="form-check text-start">
      <label class="form-check-label">
        <input type="checkbox" id="remember" class="form-check-input" name="remember" [(ngModel)]="rememberEmail">
        <span i18n>Remember me</span>
      </label>
    </div>

    <!-- ERROR OCCURED -->
    <div class="theme-error-color" *ngIf="status">
      <span class="my-3 text-center" *ngIf="status === 'WAIT'">
        <fa-icon [icon]="faSpinner" animation="spin"></fa-icon>&nbsp;<ng-container i18n>Verifying the credentials</ng-container>
      </span>
      <span class="my-3 text-center" *ngIf="status !== 'WAIT'">
        <!--ng-container *ngIf="status === 'USE-GOOGLE'">The email address is linked to Google credentials.<br/>Please sign in with Google using the button below!</ng-container-->

        <ng-container *ngIf="status === 'VERIFY-EMAIL'">
          <ng-container *ngIf="!errorResendingVerification && !isVerificationResent">
            The account with the email address exists but is not verified yet.<br/>
            <span *ngIf="!isResendingVerification"><a class="cwk-link" (click)="resendVerificationEmail()">Resend the verification email</a>.</span>
            <span class="theme-link-color"*ngIf="isResendingVerification"><fa-icon class="me-1" [icon]="faSpinner" animation="spin"></fa-icon>Resending the verification email...</span>
          </ng-container>
          <ng-container *ngIf="!errorResendingVerification && isVerificationResent">
            The email with the verification link has been sent to your email address. If you don't see the email, check your Spam folder.
          </ng-container>
          <ng-container *ngIf="errorResendingVerification">
            Error occured while resending the email with the verification link: {{ errorResendingVerification }}
          </ng-container>
        </ng-container>

        <ng-container *ngIf="!['USE-GOOGLE', 'VERIFY-EMAIL'].includes(status)">{{ status }}</ng-container>
      </span>
    </div>

    <!-- BUTTONS -->
    <div class="d-grid d-sm-flex gap-3 justify-sm-content-between my-4">
      <button class="btn btn-theme-outline-primary py-3 w-100" (click)="cancel()" type="button">Cancel</button>
      <button class="btn btn-theme-primary py-3 w-100" [disabled]="(!loginForm.form.valid) || (status === 'WAIT')" type="submit">Sign In</button>
    </div>

    <!-- SIGN UP -->
    <div class="mt-3">
      Don't have an account? <a class="cwk-link theme-link-color" (click)="createAccount()">Sign Up</a>
    </div>
  </div>
</form>
